<template>
    <div class="common-t">
        <div class="common-t__bg">
            <Header class="common-t__header"/>
            <slot name="top"/>
            <div class="common-t__content">
                <slot/>
            </div>
        </div>
        <Footer class="common-t__footer"/>
    </div>
</template>

<script>
import './common-t.scss'
import Header from '@/components/common/header/Header'

export default {
    name: 'CommonTemplate',
    components: {
        Header,
        Footer: () => import('@/components/common/footer/Footer')
    }
}
</script>